import {
  RETURNS_ANNEXURE_COLUMNS,
  RETURNS_ANNEXURE_COLUMNS_27Q,
} from '../../../../constants/returnsStep'
import { getAnnexureColumns } from '../../../../hooks/useAnnexture'
import CommonTable from '../../../common/CommonTable'

function ReturnsAnnexure({ editMode, formHook, annextureHook, formVersion }) {
  let formType = formHook?.formData?.formType || {}
  let financialYear = formHook?.formData?.financialYear || ''

  // Use version-aware column selection
  const columns =
    formVersion === 'new'
      ? getAnnexureColumns(
          financialYear,
          formType,
          annextureHook.sectionCodeOptions
        )
      : formType == '27Q'
        ? RETURNS_ANNEXURE_COLUMNS_27Q
        : RETURNS_ANNEXURE_COLUMNS
  return (
    <CommonTable
      columns={columns}
      loading={annextureHook.loadingAnnexture}
      data={annextureHook.annextureData}
      editMode={editMode}
      showCheckbox={false}
      showActions={false}
      selectedItems={annextureHook.selectedRows}
      onSelectItem={id =>
        annextureHook.setSelectedRows(prev =>
          prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        )
      }
      onSelectAll={e =>
        annextureHook.setSelectedRows(
          e.target.checked ? annextureHook.annextureData.map(r => r.uuid) : []
        )
      }
      onFieldChange={annextureHook.handleFieldChange}
      onPageChange={annextureHook.handlePageChange}
      onItemsPerPageChange={annextureHook.handleItemsPerPageChange}
      totalItems={annextureHook.totalItems}
      editingData={annextureHook.editingData}
      currentPage={annextureHook.currentPage}
      itemsPerPage={annextureHook.itemsPerPage}
      showFooter={true}
    />
  )
}

export default ReturnsAnnexure
